"use client";

// The provider half of the private `packages/sdk/react/src/tools/tool-view.tsx`,
// split out of `./tool-view-context.ts` because JSX needs a `.tsx` module.
// Mounted by the block around the transcript (plan-024b parity pass) so
// `useToolAutoOpen` observes a real context and expandable tool rows toggle
// again — the frozen-expandable gap from plans/030a-tool-view-strategy.md §5.
import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useCallback, useMemo, useState } from "react";
import { ToolViewContext, type ToolViewContextType } from "./tool-view-context";
type ToolViewProviderProps = {
  children: ReactNode;
  autoOpen?: boolean;
};
export function ToolViewProvider(t0) {
  const $ = _c(14);
  const {
    children,
    autoOpen: t1
  } = t0;
  const autoOpen = t1 === undefined ? false : t1;
  const [autoOpenId, setAutoOpenId] = useState(null);
  const [manuallyOpened, setManuallyOpened] = useState(_temp);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = id => {
      setAutoOpenId(id);
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const setAutoOpen = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = id_0 => {
      setManuallyOpened(prev => {
        if (prev.has(id_0)) {
          return prev;
        }
        const next = new Set(prev);
        next.add(id_0);
        return next;
      });
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const registerManualOpen = t3;
  let t4;
  if ($[2] !== autoOpenId || $[3] !== manuallyOpened) {
    t4 = {
      autoOpenId,
      manuallyOpened
    };
    $[2] = autoOpenId;
    $[3] = manuallyOpened;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      setAutoOpen,
      registerManualOpen
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== autoOpen) {
    t6 = {
      autoOpenEnabled: autoOpen
    };
    $[6] = autoOpen;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t6) {
    t7 = {
      state: t4,
      actions: t5,
      meta: t6
    };
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const value = t7;
  let t8;
  if ($[11] !== children || $[12] !== value) {
    t8 = <ToolViewContext.Provider value={value}>{children}</ToolViewContext.Provider>;
    $[11] = children;
    $[12] = value;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}
function _temp() {
  return new Set();
}